import { CareerOptions } from 'src/services/api/options/careerOptions';

export const careerKeys = {
  all: ['career'] as const,
  lists: () => [...careerKeys.all, 'list'] as const,
  list: (options: CareerOptions, searchString: string) => [...careerKeys.lists(), options.Category, options.Status, searchString] as const,
  byId: (careerItemGuid: string) => [...careerKeys.all, careerItemGuid] as const,
};
